/**
 * Shown while a lazy route chunk is loading — keep minimal to avoid extra layout shift.
 */
export function RouteFallback() {
  return (
    <div
      className="min-h-[50vh] flex flex-col items-center justify-center gap-3"
      aria-busy="true"
      aria-label="Loading page"
    >
      <div className="h-9 w-9 rounded-full border-2 border-partner-border-strong border-t-partner-primary animate-spin" />
      <p className="text-sm text-partner-ink-muted-500">Loading…</p>
    </div>
  );
}
